import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {buildInteractionIdProps} from '../../../../libs/shared/helpers/src/interaction/interactionHelpers';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

interface SidebarBoxProps {
  children?: ReactNode;
  interactionId?: string;
  icon: ReactNode;
  title: ReactNode;
}

/*
 * Style.
 */

export const StyledEditorSidebarWrapperDiv = styled.div`
  width: 268px;
  min-width: 268px;
`;

const StyledEditorSidebarSection = styled.section<{$color?: string; $hasBorder?: boolean}>`
  background-color: ${({$color, theme}) => $color ?? theme.greys.shade10};

  border-radius: 14px;
  ${(p) =>
    p.$hasBorder &&
    css`
      border: 1px solid ${p.theme.greys.shade30};
    `}

  padding: 15px;
  margin-bottom: 15px;

  line-height: 1.5;
`;

const StyledEditorSidebarSectionTitleDiv = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto 1fr;
  align-items: self-start;
  justify-content: center;

  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
`;

const StyledEditorSidebarListWrapperDiv = styled.div`
  ul {
    padding-left: 0;
    list-style: none;

    > li:not(:last-of-type) {
      margin-bottom: 12px;
    }
  }
`;

export const StyledMultipleButtonWrap = styled.div`
  ${flexCenter};
  justify-content: flex-end;
  gap: 12px;
`;

/*
 * Component.
 */

export const SidebarBox: FC<SidebarBoxProps> = ({interactionId, icon, title, children}) => {
  const theme = useUserTheme();

  return (
    <StyledEditorSidebarWrapperDiv>
      <StyledEditorSidebarSection
        $color={theme.greys.white}
        $hasBorder
        {...buildInteractionIdProps(interactionId)}
      >
        <StyledEditorSidebarSectionTitleDiv>
          {icon}
          {title}
        </StyledEditorSidebarSectionTitleDiv>
        <StyledEditorSidebarListWrapperDiv>{children}</StyledEditorSidebarListWrapperDiv>
      </StyledEditorSidebarSection>
    </StyledEditorSidebarWrapperDiv>
  );
};
